export const ACTIONS = {
	/**
	 * Manage base application tables.
	 */
	BASE: 'App Tables',
	/**
	 * Manage request lifecycle notifications.
	 */
	NOTIFICATIONS: 'Email Notifications',
	/**
	 * Manage single- and multi-level approvals.
	 */
	APPROVALS: 'Approvals',
	/**
	 * Manage application extensions.
	 */
	EXTENSIONS: 'Extensions',
	/**
	 * Manage application form components.
	 */
	COMPONENTS: 'Components',
	/**
	 * Manage application dependency mappings.
	 */
	APP_DEPENDENCY: 'App Dependency',
	/**
	 * Manage on-premise AD group associations.
	 */
	AD_GROUPS: 'AD Groups',
	/**
	 * Manage cloud group associations.
	 */
	CLOUD_GROUPS: 'Cloud Groups',
	/**
	 * Manage EU group associations.
	 */
	EU_GROUPS: 'EU Groups',
	/**
	 * Manage application distribution list associations.
	 */
	DL: 'Distribution Lists',
	/**
	 * Manage application work queue configuration.
	 */
	WORK_QUEUE: 'Work Queues',
	/**
	 * Enable application for service account request flow(s).
	 */
	SERVICE_ACCOUNTS: 'Service Accounts',
};
export const AUTHORIZEDROLES = ['DEV Team'];

export const CAN_TOGGLE_SAFETY = ['DEV Team'];

export const AD_TYPES = {
	ON_PREM: 'ON_PREM',
	CLOUD: 'CLOUD',
	EU: 'EU',
};
export const WORK_QUE_TYPES = {
	DESIGNATED_WQ: 'DESIGNATED_WQ',
	ADD_TO_EXISTING_WQ: 'ADD_TO_EXISTING_WQ',
	AUTO_COMPLETE: 'AUTO_COMPLETE',
	DEFER_TO_IMPORT: 'DEFER_TO_IMPORT',
};

/**
 * App IDs for which the App Dependency tab should not be shown.
 */
export const APP_DEPENDENCY_EXCLUDED_APP_IDS = [18, 23, 749, 750];
